import styled from 'styled-components';
import { Checkbox } from 'ui/checkboxV2';
import { useSelectionContext } from '../../../contexts/SelectionContext';
import { MemberRow } from '../types';
import { TableCell } from './styled';

const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  gap: 0;
`;

export const SelectionCell = ({ row }: { row: MemberRow }) => {
  const { selected, toggleSelection } = useSelectionContext();

  return (
    <TableCell>
      <StyledCheckbox
        id={`select-${row.id}`}
        label=""
        status={selected.includes(row.id)}
        setChecked={() => {
          toggleSelection(row.id);
        }}
      />
    </TableCell>
  );
};
